<template>
  <div class="checkboxes-input">
    <fieldset class="form-group">
      <div class="row">
        <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
          {{ options.label }}
          <span v-if="options.required" class="required">*</span>
        </label>
        <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
          <div class="card">
            <ul class="list-group list-group-flush" v-for="(object, index) in options.objects" :key="index">
              <li class="list-group-control">
                <label class="custom-control material-checkbox">
                  <input type="checkbox" class="material-control-input"
                    :value="options.objectValue ? object[options.objectValue] : object.uuid"
                    :id="options.objectValue ? object[options.objectValue] : object.uuid"
                    :checked="value.includes(options.objectValue ? object[options.objectValue] : object.uuid)"
                    :name="options.name + '[]'"
                    @change="validate($event)">
                  <span class="material-control-indicator"></span>
                  <span class="material-control-description">
                    <img v-if="options.icon && object[options.icon]" class="nav-item-img" :src="'https://s3-ap-southeast-2.amazonaws.com/roscon/' + object[options.icon].objectKey">
                    <span v-html="object[options.objectName]"></span>
                  </span>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'CheckboxesInput',
  props: {
    value: {
      type: Array
    },
    options: {
      type: Object,
      default () {
        return {
          label: '',
          name: '',
          required: false
        }
      }
    }
  },
  data () {
    return {
      isValid: true
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage
  },
  methods: {
    validate (event = false) {
      let value = this.value
      if (event) {
        if (value.includes(event.target.value)) {
          value = value.filter((el) => event.target.value !== el)
        } else {
          value = [ ...value, event.target.value ]
        }
      }
      this.$emit('input', value)
    },
    runWatcher (val, name) {
      if (this.options.watchers.includes(name)) {
        switch (name) {
          case 'admin':
            if (val) {
              let value = []
              for (let object of this.options.objects) {
                value.push(object.uuid)
              }
              this.$emit('input', value)
            }
            break
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/CheckboxesInput.vue